/** FuryBot — Beginner Walkthrough Flow */
import { track } from "../utils/analytics";
import { BEGINNER_STEPS } from "../constants";

export function createBeginnerFlowHandlers(ctx) {
  const { addBot, setBeginnerStep } = ctx;

  const startBeginnerFlow = () => {
    track("flow_started", { flow: "beginner" });
    setBeginnerStep(0);
    addBot("Welcome! Prop trading usually works in three stages:\n\n1. Buy an evaluation account\nYou purchase a challenge and must trade while following the firm's rules.\n\n2. Reach the profit target while respecting the firm's rules\nThis usually includes drawdown limits, consistency requirements, and sometimes restrictions on news trading or automated strategies.\n\n3. Pass the evaluation and receive a funded account stage\nMost firms first provide a simulated funded account that pays real withdrawals. Some firms may later move traders to live capital after consistent payouts, depending on the firm.\n\nHow would you like to proceed?", [
      { label: "Quick \u2014 Pick my first firm", action: "beginner_quick" },
      { label: "Walk me through everything", action: "beginner_walk", data: "0" },
    ]);
  };

  const showBeginnerStep = (stepNum) => {
    const step = BEGINNER_STEPS[stepNum];
    if (!step) return;
    setBeginnerStep(stepNum);
    const buttons = [];
    if (step.next) buttons.push({ label: `${step.next}`, action: "beginner_walk", data: String(stepNum + 1) });
    else {
      buttons.push({ label: "Pick my first firm", action: "beginner_quick" });
      buttons.push({ label: "Show cheapest options", action: "deals_all" });
      buttons.push({ label: "Beginner guide", action: "link", data: "/best-futures-prop-firms-for-beginners" });
    }
    buttons.push({ label: "Main menu", action: "home" });
    addBot(`**${step.title}**\n\n${step.text}`, buttons);
  };

  return { startBeginnerFlow, showBeginnerStep };
}
